import AI_Icon from '@icons/svg/ai_icon.svg?react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { splitStringToWords } from '../../../utils/miscellaneous/modifyString';
import { ConditionalRendering } from '../utils';
import { CALL_ANALYSIS_KEYS_ORDER } from './common/accountActivity.constants';
import { InteractionData } from './common/types';

interface Props {
    aiCallAnalysis?: InteractionData;
}

const renderKeyValueRows = (obj: InteractionData) => {
    return Object?.entries(obj).map(([key, value], idx) => (
        <div key={idx} className="session-details" data-testid={`session-details-${key}`}>
            <span className="title" data-testid={`session-title-${key}`}>
                {splitStringToWords(key)}:
            </span>
            <span className="description" data-testid={`session-description-${key}`}>
                {Array.isArray(value) ? value.join(', ') : value}
            </span>
        </div>
    ));
};

const renderSection = (obj: InteractionData) => {
    return CALL_ANALYSIS_KEYS_ORDER.map((key, idx) => (
        <div className="sub-analysis-section" key={idx} data-testid={`sub-analysis-section-${key}`}>
            <div className="subsection-title" data-testid={`subsection-title-${key}`}>
               
                {splitStringToWords(key)}
            </div>
            {obj[key]?.map((data, i) => (
                <div key={i} data-testid={`sub-analysis-row-${key}-${i}`}>
                    {renderKeyValueRows(data)}
                </div>
            ))}
        </div>
    ));
};

const AICallAnalysis: React.FC<Props> = ({ aiCallAnalysis }) => {
    return (
        <div className="analysis-section" data-testid="analysis-section">
            <div className="section-title" data-testid="section-title">
                <AI_Icon className="icon-primary" data-testid="ai-icon" />
                <span data-testid="ai-call-summary-title">
                    <FormattedMessage id="member.account.activity.aiCallSummary" />
                </span>
            </div>
            <ConditionalRendering isTrue={!aiCallAnalysis}>
                <span className="no-data" data-testid="ai-call-summary-no-data">
                    <FormattedMessage id="member.account.activity.aiCallSummary.noData" />
                </span>
            </ConditionalRendering>
            <ConditionalRendering isTrue={!!aiCallAnalysis}>
                {aiCallAnalysis && renderSection(aiCallAnalysis)}
            </ConditionalRendering>
        </div>
    );
};

export default AICallAnalysis;
